import { AloBase } from '@/models/alo/AloBase';

export interface IAloBaseArray
{
    items:Array<any>
    length:number 
    itemTypeName:string
}

export class AloBaseArray<T extends AloBase> implements IAloBaseArray {
        
    public items:Array<T>
    public length:number 
    public itemTypeName:string

    constructor(c: new (item:any) => T,{ items, length, itemTypeName  }: IAloBaseArray) {
        this.items = items.map(i => new c(i))   
        this.length = length
        this.itemTypeName = itemTypeName
    }
}